import React, { Component } from 'react'
import { PermissionContext } from 'src/components/auth/PermissionContext'

export default function withPermissions(ComponentWithPermissions) {
    return class extends Component {
        static contextType = PermissionContext
        render() {
            return (
                <ComponentWithPermissions
                    permissions={this.context}
                    {...this.props}
                />
            )
        }
    }
}
